import { Highlights } from "./types/highlights";
import { fetchWithRetry } from "../client";
import { cmsLang, type Locale } from "@/i18n/config";

export async function fetchHighlights(
  lang: Locale,
): Promise<Highlights[]> {
  const res = await fetchWithRetry<{ data: Highlights[] }>(
    `/highlights?lang=${cmsLang(lang)}`,
  );
  return res.data.map(
    (item): Highlights => ({
      id: item.id,
      nombre: item.nombre,
      url: item.url,
      banner: item.banner,
    }),
  );
}
